export const DOCKET_SHOP_MISMATCH = 'MISMATCH';
export const DOCKET_SHOP_VALIDATION_UNAVAILABLE = 'UNAVAILABLE';

export function validateDocketShopTeam(profile, expectedTeamId) {
  if (!expectedTeamId) return undefined;
  if (!profile) return DOCKET_SHOP_VALIDATION_UNAVAILABLE;
  if (!profile.teamId) return DOCKET_SHOP_VALIDATION_UNAVAILABLE;
  return profile.teamId === expectedTeamId ? undefined : DOCKET_SHOP_MISMATCH;
}
